/**
 * Corporacao recem-cadastrada, ainda sem as tabelas do ata: a API responde 503 com `code: corporation_not_ready` (EnsureCorporationReady,
 * no ata-api) em vez de um erro de banco, e a tela mostra uma pagina de espera. Aqui fica so o que se decide sem Vue, para dar para testar.
 */

export const NOT_READY_CODE = 'corporation_not_ready';

/** De quanto em quanto tempo a tela de espera pergunta se ja da para entrar, se a API nao disser (e dentro destes limites se disser). */
export const DEFAULT_SECONDS = 15;
const MIN = 5;
const MAX = 120;

/** O erro e o aviso "estamos preparando a sua empresa"? Um 503 qualquer (API fora do ar, por exemplo) NAO e: so o que traz o codigo. */
export function isCorporationNotReady(error) {
    return error?.response?.status === 503 && error.response?.data?.code === NOT_READY_CODE;
}

/** Em quantos segundos perguntar de novo: o que a API pediu, limitado a 5-120 (um valor absurdo nao pode travar nem sobrecarregar a tela). */
export function secondsToRetry(error) {
    const requested = Number(error?.response?.data?.retry_after);

    if (!Number.isFinite(requested) || requested <= 0) return DEFAULT_SECONDS;

    return Math.min(MAX, Math.max(MIN, Math.round(requested)));
}
